export default __webpack_public_path__ + "static/media/Cuisse of the Sanguine Disciple.e68a8a3b.jpg";